// extracted by mini-css-extract-plugin
export default {"container":"tradeInformation_container__bi31n","icon":"tradeInformation_icon__BmV7k","iconButton":"tradeInformation_iconButton__3dQ33","content":"tradeInformation_content__lSnkR"};